export enum HomePlacementErrors {
  PROPERTY_BOUNDARY_ERROR = 'PROPERTY_BOUNDARY_ERROR',
  FLOOD_ZONE_WARNING = 'FLOOD_ZONE_WARNING',
  WETLAND_ERROR = 'WETLAND_ERROR',
  SETBACK_ERROR = 'SETBACK_ERROR',
}
